import { PaymentFormData } from "@/Components/UI/Onboarding/Client/PaymentForm/PaymentForm";
import { ConditionalFaqItemType } from "@/Pages/Client/PaymentPage/Partials/PaymentFAQItem";
import {
    applyDiscountToCents,
    formatMoneyWithCurrency,
} from "@/utils/moneyFormatting";
import { FaScaleUnbalanced } from "react-icons/fa6";

export function getTakeTheBetFaqItem(
    paymentFormData: PaymentFormData,
): ConditionalFaqItemType | null {
    if (!paymentFormData.showTakeTheBetFaq) {
        return null;
    }

    const baseTrialCostCents =
        paymentFormData.pricingVersion.trialCostAmountCentsPerPriceGroup
            ?.default ??
        paymentFormData.pricingVersion.trialCostAmountCents ??
        0;
    const trialPriceForDisplay = formatMoneyWithCurrency(
        applyDiscountToCents(
            baseTrialCostCents,
            paymentFormData.promotionCode?.coupon,
        ),
        paymentFormData.prices[0]?.currency ?? "usd",
    );

    return {
        icon: <FaScaleUnbalanced />,
        title: "How do I know this is a good use of my time and money?",
        description: (
            <div className="flex flex-col gap-3 -mb-8">
                <p>
                    The honest answer: you don't until you try it. So how do you
                    decide if it's worth trying? Here's a perspective from our
                    founder:
                </p>
                <p className="italic">
                    “One of the best pieces of advice I ever got: when you see
                    an asymmetric bet (a bet where the upside is very large and
                    the downside is limited), take it. I've applied it to every
                    major career and life decision since.
                </p>
                <p className="italic">
                    We designed our trial to be one of those bets. Best case,
                    coaching works for you and it's life-changing. Worst case,
                    you spent {trialPriceForDisplay} for an hour of conversation
                    with a professional coach about your goals.”
                </p>
            </div>
        ),
    };
}
